export default "__VITE_ASSET__C7v1g2ih__"